
import { Component, Vue, Watch } from 'vue-property-decorator';
import authProvider from '@/utility/authProvider';
import { APP_CONFIG } from '@/config/app-config';
import { Auth } from '@/models/auth';
import authService from '@/services/auth-services';
import localStorage from '@/utility/localStorage';
import Notification from './Notification.vue';
import commonService from '@/services/common-services';
import { CommonActionType } from '@/store/modules/common/action.type';

@Component({
    components: {
        'notification': Notification
    }
})
export default class AppHeader extends Vue {
    private isOpenMenuUser = false;
    private totalNotify = 0;

    get showMenuLeft() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].showMenuLeft;
    }

    get userInfo() {
        return this.$store.state[APP_CONFIG.stateKey.authStore].userInfo;
    }

    get customerInfo() {
        return this.$store.state[APP_CONFIG.stateKey.authStore].customerInfo;
    }

    get chinaAddress() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].chinaAddress;
    }

    get isToken() {
        return authProvider.isToken();
    }

    private onOpenUserMenu() {
        this.isOpenMenuUser = !this.isOpenMenuUser;
    }

    private async onLogout() {
        const dataRequest: Auth = {
            username: '',
            password: '',
            FirebaseToken: localStorage.get('FCM_Token')
        };

        const result  = await authService.logout(dataRequest);
        (window['getApp'] as any).$emit('APP_LOGOUT');
    }

    private onToggleMenu() {
        (window['getApp'] as any).$emit('SHOW_HIDE_MENU_LEFT', !this.showMenuLeft);
    }

    private getTotalNotification(total: number) {
        this.totalNotify = total;
    }

    private async created() {
        if (!this.chinaAddress && this.customerInfo && this.customerInfo.ChinaStoreID) {
            await this.loadChinaAddress();
        }
    }

    @Watch('customerInfo')
    private async onCustomerInfoChanged(val: any) {
        if (!this.chinaAddress && val && val.ChinaStoreID) {
            await this.loadChinaAddress();
        }
    }

    private async loadChinaAddress() {
        const result = await commonService.getDetailChinaStore(this.customerInfo.ChinaStoreID);
        if (result && result.status === 200) {
            const address = `${result.data.data.Receiver}${this.customerInfo.ID} - ${result.data.data.Phone} - ${result.data.data.Address.replaceAll('DL', 'DL' + this.customerInfo.ID)}`;
            this.$store.dispatch(`${APP_CONFIG.stateKey.commonStore}/${CommonActionType.SetChinaAddress}`, address);
        }
    }
}
